export default "__VITE_ASSET__C6BqPCV3__"